// extracted by mini-css-extract-plugin
module.exports = {"instaBlock":"insta-module--instaBlock--35zIP","caption":"insta-module--caption--1vHT4"};